import { styled } from '../../../common/ui'

export const FieldContainer = styled.div`
  margin: 0 0 5px 0;
`
